import { AccordionDetails, styled } from '@mui/material';

export const CustomAccordionBodyStyled = styled(AccordionDetails)(({ theme }) => ({
  padding: `0`,
}));
